import { Navigate } from "react-router-dom";
import { Layout } from "../global/Layout";
import { useHasAllStoresAccess } from "../../utils/Permission";
import ActivityLogView from "./ActivityLogView";
import { GLOBAL_LOG_ENTITY_TYPES } from "./logUtils";

export default function GlobalActivityContainer() {
    const hasAllStoresAccess = useHasAllStoresAccess();

    if (!hasAllStoresAccess) {
        return <Navigate to="/unauthorized" replace />;
    }

    const handleGoBack = () => (window.location.href = '/stores');

    return (
        <Layout>
            <button className="back-button" onClick={handleGoBack}>Back to dashboard</button>
            <div className="page global-activity">
                <div className="container">
                    <ActivityLogView
                        entityTypes={GLOBAL_LOG_ENTITY_TYPES}
                        heading={
                            <div>
                                <h1 className="page-title">Global Activity</h1>
                                <p className="global-activity__subtitle">Actions not tied to a specific store, such as logins and user management.</p>
                            </div>
                        }
                    />
                </div>
            </div>
        </Layout>
    );
}
